var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('figure',{staticClass:"my-code"},[_c('figcaption',[_vm._v("Payload")]),_c('pre',[_c('code',{attrs:{"datatype":"JSON"}},[_vm._v(_vm._s(JSON.stringify(_vm.step, null, 2)))])])]),_c('ButtonDefault',{staticStyle:{"height":"34px","width":"100%"},attrs:{"title":"Próximo"},on:{"click":_vm.proximo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }